import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { layout } from '@prisjakt/ui-base';

const BRAND_LOGO_WIDTH = 88;
const BRAND_LOGO_HEIGHT = 31;

export const RecommendedRetailerExpansion = styled(Link)`
  display: flex;
  align-items: center;

  img {
    margin-right: 0.5rem;
    width: ${BRAND_LOGO_WIDTH}px;
    height: ${BRAND_LOGO_HEIGHT}px;
  }
`;

export const Wrapper = styled.div(
  props => css`
    display: flex;
    flex-direction: column;
    color: ${props.theme.text.secondary};

    img {
      margin-top: ${layout.spacing.xSmall};
    }
  `
);
